import { useState, useEffect, useCallback } from "react";
import './TicketDetails.css';
import { Globals as OldGlobals } from '../../global/Globals';
import Button from '../../components/Button/Button';
import { ticketDetailsByTicketId } from "../../services/GenericAPI";
import { useLocation } from "react-router-dom";
import { fetchProducer } from '../../services/api';
import { fetchHalfPageBreif, ticketStatusUpdate } from '../../services/api';
import { formatCurrency, formatDate } from '../../util/util';
import NoResultsComponent from '../../components/NoResults/NoResult';
import Loader from '../../components/Loader/Loader';
import CryptoUtils from "../../util/cryptoUtils";
import axios from '../../services/axiosInstance';
import DocumentListItem from '../../components/HalfPage_Popup/DocumentListItem';
import { useNavigate } from 'react-router-dom';
import PopUp from '../../components/PopUp/PopUp';
import {getProducerByProducerID} from '../../services/SystemAdminAPI';
import { useLanguage } from "../../context/Languagecontext";

export default function TicketDetails() {
    const { Globals ,languages, setLanguages } = useLanguage();
    const navigate = useNavigate();
    const location = useLocation();
    const [isExpand, setIsExpand] = useState(false);
    const [ticketData, setTicketDetails] = useState([]);
    const [producerData, setProducerDetails] = useState([]);
    const { ticketId, proposalId, proposalDetailId, proposalType, producerId } = location.state;
    const [loading, setLoading] = useState(false);
    const [BreifData, setBreifData] = useState([]);
    const [contentData, setContentData] = useState([]);
    const [contentDataStatus, setContentDataStatus] = useState(null);
    const [data, setData] = useState([]);
    const [proposalData, setProposalData] = useState(null);
    const [isLogLineExpanded, setIsLogLineExpanded] = useState(false);
    const [isepisodeStructureExpanded, setEpisodeStructureExpanded] = useState(false);
    const [isEditorialExpanded, setIsEditorialExpanded] = useState(false);
    const [isbrandIntegrationExpanded, setBrandIntegrationExpanded] = useState(false);
    const [isCompanyProfileExpanded, setCompanyProfileExpanded] = useState(false);
    const [iscastPresenterInfoExpanded, setCastPresenterInfoExpanded] = useState(false);
    const [islocationStudioInfoExpanded, setLocationStudioInfoExpanded] = useState(false);
    const [fileItems, setFileItems] = useState([]);
    const [isProposalExpand, setProposalExpand] = useState(false);
    const [isSynopsisExpanded, setIsSynopsisExpanded] = useState(false);
    const [popupState, setPopupState] = useState(null);
    const [createdOnDateFormat, setCreatedOnDateFormat] = useState("");
    const [resolvedOnDateFormat, setResolvedOnDateFormat] = useState("");
    const [ticketContentDataStatus, setTicketContentDataStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isprojectStatusExpanded, setProjectStatusExpanded] = useState(false);
    const [iskeyTeamsExpanded, setKeyTeamsExpanded] = useState(false);
    const [ticketFileItem, setTicketFileItem] = useState({});

    const ticketDetailsRequest = async () => {
        setIsLoading(true);
        try {
            ticketDetailsByTicketId(ticketId)
            .then((response) => {
                if (response.data.status === "OK") {
                    const dataTicketDetails = response.data.content;
                    setTicketDetails(dataTicketDetails);
                    createdOnDate(dataTicketDetails);
                    if(dataTicketDetails.refImagePath !== null){
                        setTicketFileItem({foundDoc: dataTicketDetails.refImagePath, docFor: dataTicketDetails.refImagePath.documentFor, heading: Globals.SOLICITED_PROPOSAL.DOCUMENTS.TKTDOC, isDownload: true})
                    }
                    if(proposalType !== 1){
                        getData(dataTicketDetails.ticketType);
                    }
                    if(dataTicketDetails){
                        getProposalData(dataTicketDetails.ticketType);
                    }
                    setIsLoading(false);
                } else {
                    setPopupState("Retry");
                }
            }).catch(() => {
                setPopupState("Retry");
            });
            
        } catch(error) {
            console.log('Error');
            setTicketContentDataStatus("Error");
            setIsLoading(false);
        }
    }

    const producerDetailsRequest = async () => {
        try {
            if(CryptoUtils.getFromLocalStorage("roleId")[0] === 4 || CryptoUtils.getFromLocalStorage("roleId") === '4' || CryptoUtils.getFromLocalStorage("roleId")[0] === 1 || (CryptoUtils.getFromLocalStorage("roleId") === '3') || CryptoUtils.getFromLocalStorage("roleId")[0] === 3){
                const response = await getProducerByProducerID(producerId);
                const producerDetails = response.data.content.producer;
                setProducerDetails(producerDetails);
            } else if(CryptoUtils.getFromLocalStorage("roleId")[0] === 5){
                const response = await fetchProducer();
                const producerDetails = response.content.producer;
                setProducerDetails(producerDetails);
            }
        } catch(error) {
            console.log('Error', error);
        }
    }

    const resetStates = useCallback(() => {
           setPopupState(null);
       }, []);

    const handleBack = useCallback(() => {
            if (popupState === "resolve") {
                updateStatus();
            } else {
                navigate(OldGlobals.NAVPATH.TICKETS, { state: { activeHeader: "tickets" } });
            }
        }, [navigate, popupState]);

    const showPopup = useCallback(
            (title, message, button1) => (
                <PopUp
                    title={title}
                    text={message}
                    normalAction={popupState !== "cross" ? handleBack : null}
                    normalActionText={popupState !== "cross" ? button1 : ""}
                    negativeAction={popupState === "cross" ? handleBack : null}
                    negativeActionText={popupState === "cross" ? button1 : ""}
                    popupType="abort"
                    onClose={resetStates}
                    buttonBGColor={popupState !== "cross" ? "#004894" : ""}
                />
            ),
            [handleBack, resetStates, popupState]
        );

    const updateStatus =async () => {    
            await ticketStatusUpdate(ticketId)
                .then((response) => {
                    if (response.data.status === "OK") {
                        setPopupState(null);
                        navigate(OldGlobals.NAVPATH.TICKETS, { state: { toastValue: Globals.RAISE_TICKET.RESOLVE_BTN_TOAST_SUCCESS_MSG} });
                    } else {
                       navigate(OldGlobals.NAVPATH.TICKETS, { state: { toastValue: Globals.TOAST_FAILURE} });
                    }
                }).catch(() => {
                    setPopupState("Retry");
                });
        }

    const toggleSynopsis = () => {
        setIsSynopsisExpanded(!isSynopsisExpanded);
    };
    const toggleLogLine = () => {
        setIsLogLineExpanded(!isLogLineExpanded);
    };

    const toggleEpisode = () => {
        setEpisodeStructureExpanded(!isepisodeStructureExpanded);
    };
    const toggleeditorial = () => {
        setIsEditorialExpanded(!isEditorialExpanded);
    };
    const toggleBrand = () => {
        setBrandIntegrationExpanded(!isbrandIntegrationExpanded);
    };
    const toggleCompanyProfile = () => {
        setCompanyProfileExpanded(!isCompanyProfileExpanded)
    }
    const toggleCast = () => {
        setCastPresenterInfoExpanded(!iscastPresenterInfoExpanded);
    };
    const toggleLocation = () => {
        setLocationStudioInfoExpanded(!islocationStudioInfoExpanded);
    };

    const toggleProjectStatus = () => {
        setProjectStatusExpanded(!isprojectStatusExpanded);
    };

    const toggleKeyteam = () => {
        setKeyTeamsExpanded(!iskeyTeamsExpanded);
    };

    const createdOnDate = (dataTicketDetails) => {
        const date = new Date(dataTicketDetails.createdOn);
        const dateString = new Date(date?.getTime() - date.getTimezoneOffset() * 60000).toISOString().split("T")[0];
        const dateformat = (datestring) => {
            const date = new Date(datestring);
            const day = date.getDate();
            const month = date.toLocaleString("default", { month: "short" });
            const year = date.getFullYear();
            return `${day} ${month} ${year}`;
        };
        const resolvedDate = dataTicketDetails.resolvedOn !== '0001-01-01T00:00:00' ? new Date(dataTicketDetails.resolvedOn) : null;  
        if(resolvedDate !== null){
            const resolvedDateString = new Date(resolvedDate.getTime() - resolvedDate.getTimezoneOffset() * 60000).toISOString().split("T")[0];
            const resolvedDateformat = (resolvedDateString) => {
                const date1 = new Date(resolvedDateString);
                const day = date1.getDate();
                const month = date1.toLocaleString("default", { month: "short" });
                const year = date1.getFullYear();
                return `${day} ${month} ${year}`;
            };
            setResolvedOnDateFormat(resolvedDateformat(resolvedDateString))
        }
        setCreatedOnDateFormat(dateformat(dateString));
    }
    const handleReload = () => {
        getData();
    }

    const handleReloadTickets = () => {
        ticketDetailsRequest();
    }

    const getData = async (ticketDataType) => {
            try {
                setLoading(true);
                if(ticketDataType !== Globals.TICKET_TYPE.OTHER){
                const result = await fetchHalfPageBreif(
                    OldGlobals.ENDPOINT.HALFPAGE_BRIEF,
                    proposalId
                );
                setLoading(false)
                const {
                    createdByName,
                    countryName,
                    productionTypeName,
                    channelName,
                    formatName,
                    languageName,
                    genreName,
                    contentTypeName,
                    clusterName,
                    description,
                    submissionRequirements,
                    evalAndSelection,
                    commisioningEditors,
                    closingDate,
                    briefTypeName,
                    ceEvalDeadline,
                    smEvalDeadline,
                    producers
                } = result.content;
                setContentData([
                    { Description: description },
                    { "Submission Requirements": submissionRequirements },
                    { "Evaluation Process": evalAndSelection },
                ]);
                const ceJoints = commisioningEditors?.join(",");
                if(CryptoUtils.getFromLocalStorage("roleId")[0] === 5){
                    setBreifData([
                        { name: Globals.BRIEF_DATA_KEYS["CREATED BY"], description: createdByName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["CLOSING DATE"], description: formatDate(closingDate) },
                        { name: Globals.BRIEF_DATA_KEYS["CHANNEL"], description: channelName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["FORMAT"], description: formatName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["COUNTRY"], description: countryName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["PRODUCTION TYPE"], description: productionTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["SCRIPTED / \n NON-SCRIPTED"], description: contentTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["GENRE"], description: genreName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["LANGUAGE"], description: languageName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["CLUSTER"], description: clusterName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                    ])
                    setData([result?.content]);
                } else {
                    setBreifData([
                        { name: Globals.BRIEF_DATA_KEYS["CREATED BY"], description: createdByName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["CLOSING DATE"], description: formatDate(closingDate) },
                        { name: Globals.BRIEF_DATA_KEYS["CHANNEL"], description: channelName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["FORMAT"], description: formatName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["COUNTRY"], description: countryName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["PRODUCTION TYPE"], description: productionTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["SCRIPTED / \n NON-SCRIPTED"], description: contentTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["GENRE"], description: genreName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["LANGUAGE"], description: languageName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["CLUSTER"], description: clusterName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS["COMMISSIONING \n EDITIORS"], description: commisioningEditors.length ? commisioningEditors.join() : Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_TYPE, description: briefTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.CE_EVALUATION_DEADLINE, description: ceEvalDeadline && formatDate(ceEvalDeadline) || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.SM_EVALUATION_DEADLINE, description: smEvalDeadline && formatDate(smEvalDeadline) || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                        { name: Globals.BRIEF_DATA_KEYS.PRODUCERS, description: producers.join(', ') || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                    ])
                    setData([result?.content]);
                }
            }
    
            } catch (error) {
                setLoading(false)
                console.error("Error in App component:", error);
                setContentDataStatus("Error");
            }
        };
    
    const fetchProposalHalfPage = async (ticketType) => {
            try {
                let endPoint;
                if (ticketType === Globals.TICKET_TYPE.PROPOSAL){
                    if (proposalType !== 1) {
                        endPoint = Globals.BASE_URL + Globals.ENDPOINT.CC_SOLICITED_HALF_SCREEN_MIN_DISPLAY + 'proposalId=' + proposalId +'&roleId='+CryptoUtils.getFromLocalStorage("roleId")+ '&proposalDetailId=' + proposalDetailId;
                    } else if (proposalType === 1) {
                        endPoint = Globals.BASE_URL + Globals.ENDPOINT.CC_UNSOLICITED_HALF_SCREEN + 'proposalId=' + proposalId + '&roleId='+CryptoUtils.getFromLocalStorage("roleId")+'&proposalDetailId=' + proposalDetailId;
                    }
                    const response = await axios.get(endPoint);
                    return response;
                }
            } catch (error) {
                setContentDataStatus("Error");
                console.error("Error in App component:", error);
            }
        };

        const getProposalData = async (ticketType) => {
                const producerId = "612a8e8a-64af-4925-88bd-aef7893f3d55";
    
                try {
                    const response = await fetchProposalHalfPage(ticketType);
                    if (response.status >= 200 && response.status < 294) {
                        setProposalData(
                            Array.isArray(response?.data?.content)
                                ? response.data.content
                                : [response?.data?.content]
                        );
                    } else {
                        new Error(`API returned an error: ${response.status}`);
                    }
                    const content = response.data.content;
                    if (content && content.documents) {
                    const allDocs = content.documents;
                    const orderedItems = [];
                    const desiredOrder =
                        proposalType !== 1
                            ? ["LBMB", "PRSCH", "SHWRL", "CPRC", "RDOC"]
                            : ["PSH", "VP"];
                    desiredOrder.forEach((docFor) => {
                    const foundDoc = allDocs.find(
                        (doc) => doc.documentFor === docFor
                    );
                    let heading = "";
                    switch (docFor) {
                        case "LBMB":
                        heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.LBMB;
                        break;
                        case "PRSCH":
                        heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.PRSCH;
                        break;
                        case "SHWRL":
                        heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.SHWRL;
                        break;
                        case "CPRC":
                        heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.CPRC;
                        break;
                        case "RDOC":
                        heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.RDOC;
                        break;
                        case "PSH":
                        heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.PRSCH;
                        break;
                        case "VP":
                        heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.VP;
                        break;
                        default:
                        heading = foundDoc?.documentType || "Document";
                    }
                    orderedItems.push({foundDoc, docFor, heading, isDownload: false});
                    });
                        setFileItems(orderedItems);
                    } else {
                        setFileItems([]);
                    }
    
                } catch (error) {
                    setContentDataStatus("Error");
    
                }
            };
    useEffect(() => {
        ticketDetailsRequest();
        producerDetailsRequest();
    }, []);
  
    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
        document.body.style.overflow = "auto";
        };
    }, []);

    const handleButtonClick =
            (type) => {
                console.log(type);
                if (type === "resolve") {
                    setPopupState("resolve");
                } else {
                    setPopupState(type);
                }
            }

return (
    <div>
        <div className="SM-Half-Page-Header-Wrapper-prop">
            <div>
                <>
                    <p className="sm-unsolicated-proposal-heading">
                        {Globals.TICKET}   <label style={{ marginLeft: 8 }}>   #</label>{ticketData.ticketNo}
                    </p>{" "}
                </>
            </div>
            <span className="SM-HalfPage-close-icon-prop" onClick={() => navigate(OldGlobals.NAVPATH.TICKETS)}>
                &times;
            </span>
        </div>
        <div className="sm-main-nav">
            {ticketData ? (<div>
                <div  className="sm-proposal-unsolicated-briefs">
                    <div style={{display: 'flex'}}>
                        <div className="ticket-type-container">
                            <div className="header-ticket-type">{Globals.TICKETS_DETAIL.TICKET_TYPE}</div>
                            <div className="txt-ticket-type">{ticketData.ticketType}</div>
                        </div>
                        {ticketData.ticketType === 'Proposal' &&<div className="ticket-type-container">
                            <div className="header-ticket-type">{Globals.TICKET_TYPE.PROPOSAL}</div>
                            <div className="txt-ticket-type">{ticketData.proposal === null ? 'N/A' : ticketData.proposal}</div>
                        </div>}
                        {ticketData.ticketType === 'Brief' &&<div className="ticket-type-container">
                            <div className="header-ticket-type">{Globals.TICKET_TYPE.BRIEF}</div>
                            <div className="txt-ticket-type">{ticketData.proposal === null ? 'N/A' : ticketData.proposal}</div>
                        </div>}
                        {ticketData.ticketType === 'Other' &&<div className="ticket-type-container">
                            <div className="header-ticket-type">{Globals.TICKETS_DETAIL.CATEGORY}</div>
                            <div className="txt-ticket-type">{ticketData.category === null ? 'N/A' : ticketData.category}</div>
                        </div>}
                        <div className="ticket-type-container">
                            <div className="header-ticket-type">{Globals.TICKETS_DETAIL.PRODUCER}</div>
                            <div className="txt-ticket-type">{ticketData.producerName === null ? 'N/A' : ticketData.producerName}</div>
                        </div>
                    </div>
                    <div className="ticket-details">
                        <div className="ticket-details-container">
                            <div className="header-ticket-details">{Globals.TICKETS_PAGE.DETAILS_OF_THE_TICKET}</div>
                            <div className="txt-ticket-details">{ticketData.ticketDetails === null ? 'N/A' : ticketData.ticketDetails}</div>
                        </div>
                    </div>
                    <div className="ticket-details-img">
                        <div className="ticket-details-container">
                            <div className="header-ticket-details">{Globals.TICKETS_PAGE.REFERENCE_IMAGE}</div>
                            {ticketFileItem ? (
                                                        <div>
                                                            <DocumentListItem foundDoc={ticketFileItem.foundDoc} docFor={ticketFileItem.docFor}/>
                                                        </div>
                                                    ) : (
                                                        <p>N/A</p>
                                                    )}
                        </div>
                    </div>
                    <div style={{display: 'flex'}}>
                        <div className="ticket-date-container">
                            <div className="header-ticket-details">{Globals.TICKETS_DETAIL.CREATED_ON}</div>
                            <div className="txt-ticket-details">{ticketData.createdOn === null ? 'N/A' : createdOnDateFormat}</div>
                        </div>
                        {ticketData.status === 1 &&<div className="ticket-date-container">
                            <div className="header-ticket-details">{Globals.TICKETS_DETAIL.RESOLVED_ON}</div>
                            <div className="txt-ticket-details">{resolvedOnDateFormat}</div>
                        </div>}
                    </div>
                    <div className="ticket-details">
                        <div className="ticket-details-container">
                            <div className="header-ticket-details">{Globals.TICKETS_DETAIL.STATUS}</div>
                            <div className="txt-ticket-details" style={ticketData.status === 0 ? {color:'orange'} : {color: 'green'}}>{ticketData.status === 0 ? Globals.TICKETS_STATUS.ACTIVE : Globals.TICKETS_STATUS.RESOLVED }</div>
                        </div>
                    </div>
                </div>
                <div  className="sm-proposal-unsolicated-briefs">
                    <div className="ticket-details">
                        <div className="ticket-details-container">
                            <div className="header-ticket-details">{Globals.TICKETS_PAGE.PRODUCER_CONTACT_INFORMATION}</div>
                        </div>
                    </div>
                    <div className="producer-info-container" style={{display: 'flex'}}>
                        <div className="producer-info">
                            <div className="producer-contact-title">{Globals.SIGNUP.PHONE_NUMBER}</div>
                            <div className="producer-contact-txt">{producerData.producerType === 'Individual' ? producerData.companyContactNumber === null ? 'N/A' : producerData.companyContactNumber : producerData.companyContactNumber === null ? 'N/A' : producerData.companyContactNumber}</div>
                        </div>
                        <div className="producer-info">
                            <div className="producer-contact-title">{Globals.SIGNUP.EMAIL}</div>
                            <div className="producer-contact-txt">{producerData.producerType === 'Individual' ? producerData.email === null ? 'N/A' : producerData.email: producerData.companyEmail === null ? 'N/A' : producerData.companyEmail}</div>
                        </div>
                        <div className="producer-info">
                            {producerData.producerType === 'Company' ? <div className="producer-contact-title">{Globals.SIGNUP.COMPANY_ADDRESS}</div> : <div className="producer-contact-title">{Globals.SIGNUP.PHYSICAL_ADDRESS}</div>}
                            <div className="producer-contact-txt">{producerData.businessAddress === null ? 'N/A' : producerData.businessAddress}</div>
                        </div>
                        <div className="producer-info">
                            <div className="producer-contact-title">{Globals.SIGNUP.COUNTRY}</div>
                            <div className="producer-contact-txt">{producerData.countryName === null ? 'N/A' : producerData.countryName}</div>
                        </div>
                        <div className="producer-info">
                            <div className="producer-contact-title">{Globals.TICKETS_PAGE.PROVIENCE}</div>
                            <div className="producer-contact-txt">{producerData.provinceName === null ? 'N/A' : producerData.provinceName}</div>
                        </div>
                    </div>
                </div>
            </div>
            ) : ticketContentDataStatus && ticketContentDataStatus?.length > 0  &&(
                                                        <NoResultsComponent
                                                            data={{
                                                                message: Globals.HALF_PAGE_MESSAGE,
                                                                img: Globals.IMG.HALF_PAGE_ERROR,
                                                                submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                                                                className: 'ErrorHeader',
                                                                subclassName: 'SubError',
                                                                outerWrapper: 'HalfPageWrapper',
                                                                button: 'reload',
                                                            }}
                                                            handleReload={handleReloadTickets}
                                                        />
                                                    )}
    {ticketData.ticketType !== Globals.TICKET_TYPE.OTHER && proposalType !== 1 &&<div className="sm-proposal-unsolicated-briefs" >
        <div class="Half ">
            <div class="sm-brief-expandable-header" onClick={() => setIsExpand(!isExpand)}>
                <label class="sm-brief-accordion">{Globals.HALF_PAGE_BRIEF_DETAILS.BRIEF_DETAILS_HEADER}</label>
                <img class="sm-arrow" onClick={() => setIsExpand(!isExpand) }
                src={isExpand ? Globals.IMG.ARROW_UP : Globals.IMG.ARROW_DOWN}
                alt="toggle icon" />
            </div>
        </div>
        {isExpand && (
                                            <>
                                                <div className='sm-details-ac'>
                                                    {data?.length ? (
                                                        <div>
                                                            {contentData?.map(
                                                                (item, index) =>
                                                                    Object.values(item)[0] && (
                                                                        <div key={index} className="SM-Half-Page-Content-Wrapper">
                                                                            <div className={`${Object.keys(item)[0]==='Description'?'description-heading':'small-heading'} Half-Page-Desc-header`}>
                                                                                {/* {Object.keys(item)[0]} */}
                                                                                {Globals.SOLICITED_BRIEFS[`${Object.keys(item)[0]}`]}
                                                                            </div>
                                                                            <p className="SM-Half-Page-Form-Description">
                                                                                {Object.values(item)[0]}
                                                                            </p>
                                                                        </div>
                                                                    )
                                                            )}
        
                                                            <div>
                                                                <div className="Half-Page-Form">
                                                                    {BreifData?.map((item, index) => (
                                                                        <div key={index} className="SM-Half-Page-Form-Fields">
                                                                            <div className="SM-Half-Page-Form-fields-Bold" style={{ whiteSpace: 'pre-line' }}>
                                                                                {item.name}
                                                                            </div>
                                                                            <div className="SM-Half-Page-Form-Description">
                                                                                {item.description}
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : contentDataStatus && contentDataStatus?.length > 0 ? (
                                                        <NoResultsComponent
                                                            data={{
                                                                message: Globals.HALF_PAGE_MESSAGE,
                                                                img: Globals.IMG.HALF_PAGE_ERROR,
                                                                submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                                                                className: 'ErrorHeader',
                                                                subclassName: 'SubError',
                                                                outerWrapper: 'HalfPageWrapper',
                                                                button: 'reload',
                                                            }}
                                                            handleReload={handleReload}
                                                        />
                                                    ) : (
                                                        <div className="NoResultsComponent" style={{ height: '80vh' }}>
                                                            <Loader height={50} width={50} />
                                                        </div>
                                                    )}
                                                </div></>
                                        )}
    </div>}
    {ticketData.ticketType !== Globals.TICKET_TYPE.OTHER && proposalDetailId !== 0 && proposalType !== 1 &&<div className="sm-proposal-unsolicated-briefs">
                <div class="Half ">
                    <div class="sm-brief-expandable-header" onClick={() =>  setProposalExpand(!isProposalExpand) }>
                        <label class="sm-brief-accordion">{Globals.UNSOLICITED_PROPOSAL.PROPOSAL_DETAILS}</label>
                        <img class="sm-arrow"
                        onClick={() => setProposalExpand(!isProposalExpand) }
                        src={isProposalExpand ? Globals.IMG.ARROW_UP : Globals.IMG.ARROW_DOWN}
                        alt="toggle icon" />
                    </div>
                </div>
                    {isProposalExpand && (
                                                            <div>
                                                                <p className="sm-text-content-company">
                                                                    {proposalData?.[0]?.producerName}
                                                                    <span className="text">{" presents"}</span>
                                                                </p>
                                                                <div className="sm-proposal-title">
                                                                    {(proposalData[0]?.title || proposalData?.[0]?.projectTitle)}
                                                                </div>
                    
                                                                <div className="sm-proposal-container">
                                                                    <div className="sm-proposal-half-page-left">
                                                                        <div className="sm-proposal-heading">
                                                                            {Globals.SOLICITED_PROPOSAL.LOGLINE}
                                                                        </div>
                                                                        <p className="sm-text-content">
                                                                            {proposalData[0]?.logLine ? (
                                                                                <>
                                                                                    {proposalData[0]?.logLine.length > 294 ? (
                                                                                        <>
                                                                                            {isLogLineExpanded
                                                                                                ? proposalData[0]?.logLine
                                                                                                : `${proposalData[0]?.logLine.substring(0, 294)}...`}
                                                                                            <div className='view'>
                                                                                                <span className="sm-view-more" onClick={toggleLogLine}>
                                                                                                    {isLogLineExpanded ? "View Less" : "View More"}
                                                                                                </span></div>
                                                                                        </>
                                                                                    ) : (
                                                                                        proposalData[0]?.logLine
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                "N/A"
                                                                            )}
                                                                        </p>
                    
                                                                        <div className="sm-proposal-heading">
                                                                            {Globals.UNSOLICITED_PROPOSAL_HALF.SYNOPSIS}
                                                                        </div>
                                                                        <p className="sm-text-content">
                                                                            {proposalData[0]?.synopsis ? (
                                                                                <>
                                                                                    {proposalData[0]?.synopsis.length > 294 ? (
                                                                                        <>
                                                                                            {isSynopsisExpanded
                                                                                                ? proposalData[0]?.synopsis
                                                                                                : `${proposalData[0]?.synopsis.substring(0, 294)}...`}
                                                                                            <div className='view'>
                                                                                                <span className="sm-view-more" onClick={toggleSynopsis}>
                                                                                                    {isSynopsisExpanded ? "View Less" : "View More"}
                                                                                                </span></div>
                                                                                        </>
                                                                                    ) : (
                                                                                        proposalData[0]?.synopsis
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                "N/A"
                                                                            )}
                                                                        </p>
                    
                                                                        <div className="sm-unsolicated-heading">
                                                                            {Globals.UNSOLICITED_PROPOSAL_HALF.EPISODE_STRUCTURE}
                                                                        </div>
                                                                        <p className="sm-text-content">
                                                                            {proposalData[0]?.episodeStructure ? (
                                                                                <>
                                                                                    {proposalData[0]?.episodeStructure.length > 294 ? (
                                                                                        <>
                                                                                            {isepisodeStructureExpanded
                                                                                                ? proposalData[0]?.episodeStructure
                                                                                                : `${proposalData[0]?.episodeStructure.substring(0, 294)}...`}
                                                                                            <div className='view'>
                                                                                                <span className="sm-view-more" onClick={toggleEpisode}>
                                                                                                    {isepisodeStructureExpanded ? "View Less" : "View More"}
                                                                                                </span></div>
                                                                                        </>
                                                                                    ) : (
                                                                                        proposalData[0]?.episodeStructure
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                "N/A"
                                                                            )}
                                                                        </p>
                    
                                                                        <div className="sm-proposal-heading">
                                                                            {Globals.SOLICITED_PROPOSAL.EDITORIAL}
                                                                        </div>
                                                                        <p className="sm-text-content">
                                                                            {proposalData[0]?.editorialDetails ? (
                                                                                <>
                                                                                    {proposalData[0]?.editorialDetails.length > 294 ? (
                                                                                        <>
                                                                                            {isEditorialExpanded
                                                                                                ? proposalData[0]?.editorialDetails
                                                                                                : `${proposalData[0]?.editorialDetails.substring(0, 294)}...`}
                                                                                            <div className='view'>
                                                                                                <span className="sm-view-more" onClick={toggleeditorial}>
                                                                                                    {isEditorialExpanded ? "View Less" : "View More"}
                                                                                                </span></div>
                                                                                        </>
                                                                                    ) : (
                                                                                        proposalData[0]?.editorialDetails
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                "N/A"
                                                                            )}
                                                                        </p>
                                                                        <div className="proposal-section">
                                                                            <div className="sm-proposal-heading">
                                                                                {Globals.SOLICITED_PROPOSAL.PRELIMINARY}
                                                                            </div>
                                                                            <p className="sm-text-content">
                                                                                {proposalData[0]?.currency} {proposalData[0]?.targetBudget ?
                                                                                    formatCurrency(proposalData[0]?.targetBudget): ''}
                                                                            </p>
                                                                        </div>
                                                                        <div className="sm-unsolicated-heading">
                                                                            {Globals.UNSOLICITED_PROPOSAL_HALF.LOCATION_STUDIO_INFO}
                                                                        </div>
                                                                        <p className="sm-text-content">
                                                                            {proposalData[0]?.locationStudioInfo ? (
                                                                                <>
                                                                                    {proposalData[0]?.locationStudioInfo.length > 294 ? (
                                                                                        <>
                                                                                            {islocationStudioInfoExpanded
                                                                                                ? proposalData[0]?.locationStudioInfo
                                                                                                : `${proposalData[0]?.locationStudioInfo.substring(0, 294)}...`}
                                                                                            <div className='view'>
                                                                                                <span className="sm-view-more" onClick={toggleLocation}>
                                                                                                    {islocationStudioInfoExpanded ? "View Less" : "View More"}
                                                                                                </span></div>
                                                                                        </>
                                                                                    ) : (
                                                                                        proposalData[0]?.locationStudioInfo
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                "N/A"
                                                                            )}
                                                                        </p>
                                                                        <div className="sm-unsolicated-heading">
                                                                            {Globals.UNSOLICITED_PROPOSAL_HALF.CAST_PRESENTER_INFO}
                                                                        </div>
                                                                        <p className="sm-text-content">
                                                                            {proposalData[0]?.castPresenterInfo ? (
                                                                                <>
                                                                                    {proposalData[0]?.castPresenterInfo.length > 294 ? (
                                                                                        <>
                                                                                            {iscastPresenterInfoExpanded
                                                                                                ? proposalData[0]?.castPresenterInfo
                                                                                                : `${proposalData[0]?.castPresenterInfo.substring(0, 294)}...`}
                                                                                            <div className='view'>
                                                                                                <span className="sm-view-more" onClick={toggleCast}>
                                                                                                    {iscastPresenterInfoExpanded ? "View Less" : "View More"}
                                                                                                </span></div>
                                                                                        </>
                                                                                    ) : (
                                                                                        proposalData[0]?.castPresenterInfo
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                "N/A"
                                                                            )}
                                                                        </p>
                                                                        <div className="sm-unsolicated-heading">
                                                                            {Globals.UNSOLICITED_PROPOSAL_HALF.BRAND_INTEGRATION_OPPORTUNITIES}</div>
                                                                        <p className="sm-text-content">
                                                                            {proposalData[0]?.brandIntegration ? (
                                                                                <>
                                                                                    {proposalData[0]?.brandIntegration.length > 294 ? (
                                                                                        <>
                                                                                            {isbrandIntegrationExpanded
                                                                                                ? proposalData[0]?.brandIntegration
                                                                                                : `${proposalData[0]?.brandIntegration.substring(0, 294)}...`}
                                                                                            <div className='view'>
                                                                                                <span className="sm-view-more" onClick={toggleBrand}>
                                                                                                    {isbrandIntegrationExpanded ? "View Less" : "View More"}
                                                                                                </span></div>
                                                                                        </>
                                                                                    ) : (
                                                                                        proposalData[0]?.brandIntegration
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                "N/A"
                                                                            )}
                                                                        </p>
                                                                        <div className="proposal-section">
                                                                            <div className="sm-proposal-heading">
                                                                                {Globals.SOLICITED_PROPOSAL.COMPANY}
                                                                            </div>
                                                                            <p className="sm-text-content last">
                                                                                {proposalData[0]?.keyTeams ? (
                                                                                    <>
                                                                                        {proposalData[0]?.keyTeams.length > 294 ? (
                                                                                            <>
                                                                                                {isCompanyProfileExpanded
                                                                                                    ? proposalData[0]?.keyTeams
                                                                                                    : `${proposalData[0]?.keyTeams.substring(0, 294)}...`}
                                                                                                <div className='view'>
                                                                                                    <span className="sm-view-more" onClick={toggleCompanyProfile}>
                                                                                                        {isCompanyProfileExpanded ? "View Less" : "View More"}
                                                                                                    </span></div>
                                                                                            </>
                                                                                        ) : (
                                                                                            proposalData[0]?.keyTeams
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    "N/A"
                                                                                )}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                    
                                                                    <img src={Globals.IMG.LINE} alt="" />
                                                                    <div className="sm-proposal-right-content">
                                                                        {fileItems.length > 0 ? (
                                                                            <div>
                                                                                {fileItems.map(({ foundDoc, docFor, heading }) => <DocumentListItem foundDoc={foundDoc} docFor={docFor} heading={heading} />)}
                                                                            </div>
                                                                        ) : (
                                                                            <p>N/A</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                    
                                                            </div>
                                                        )}
            </div>}
            {ticketData.ticketType !== Globals.TICKET_TYPE.OTHER && proposalDetailId !== 0 && proposalType === 1 &&<div className="sm-proposal-unsolicated-briefs">
                <div class="Half ">
                    <div class="sm-brief-expandable-header" onClick={() =>  setProposalExpand(!isProposalExpand) }>
                        <label class="sm-brief-accordion">Proposal Details</label>
                        <img class="sm-arrow"
                        onClick={() => setProposalExpand(!isProposalExpand) }
                        src={isProposalExpand ? Globals.IMG.ARROW_UP : Globals.IMG.ARROW_DOWN}
                        alt="toggle icon" />
                    </div>
                </div>
                    {isProposalExpand && (
                                            <>
                                                <div className='sm-details-ac'>
                                                    {proposalData?.length ? <>
                                                    <div className="proposal-title">
                                                        <p className="text-content-company">
                                                            {proposalData?.[0]?.producerName}
                                                            <span className="text">{" presents"}</span>
                                                        </p>
                                                        <div className="proposal-title">
                                                            {proposalData[0]?.title ||
                                                                proposalData?.[0]?.projectTitle}
                                                        </div>
                                                    </div>

                                                    <div className="sm-proposal-container">
                                                        <div className="sm-proposal-half-page-left">
                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {Globals.UNSOLICITED_PROPOSAL_HALF.COUNTRY}{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.countryName}
                                                                </div>
                                                            </div>

                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading" style={{whiteSpace:"pre-line"}}>
                                                                    {Globals.UNSOLICITED_PROPOSAL_HALF.SCRIPTED}{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.contentName}
                                                                </div>
                                                            </div>

                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {Globals.UNSOLICITED_PROPOSAL_HALF.CLUSTER}{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.clusterName}
                                                                </div>
                                                            </div>
                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {Globals.UNSOLICITED_PROPOSAL_HALF.GENRE}{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.genreName}
                                                                </div>
                                                            </div>
                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {Globals.UNSOLICITED_PROPOSAL_HALF.CHANNEL}{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.channelName}
                                                                </div>
                                                            </div>
                                                            {proposalData[0]?.othergenre && (
                                                                <div className="unsolicated-proposal-text-width">
                                                                    <div className="unsolicated-heading">
                                                                        {Globals.UNSOLICITED_PROPOSAL_HALF.OTHERGENRE}{" "}
                                                                    </div>
                                                                    <div className="text-content-unsolicated-width">
                                                                        {proposalData[0]?.othergenre}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {Globals.UNSOLICITED_PROPOSAL_HALF.LANGUAGE}{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.languageName}
                                                                </div>
                                                            </div>

                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {
                                                                        Globals.UNSOLICITED_PROPOSAL_HALF
                                                                            .PRODUCTIONTYPE
                                                                    }{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.productionTypeName}
                                                                </div>
                                                            </div>

                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {
                                                                        Globals.UNSOLICITED_PROPOSAL_HALF
                                                                            .TARGET_AUDIENCE
                                                                    }{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.targetAudienceName}
                                                                </div>
                                                            </div>

                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {Globals.UNSOLICITED_PROPOSAL_HALF.FORMAT}{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.formatName}
                                                                </div>
                                                            </div>

                                                            {proposalData[0]?.noOfEpisodes ? (
                                                                <>
                                                                    <div className="unsolicated-proposal-text-width">
                                                                        <div className="unsolicated-heading">
                                                                            {
                                                                                Globals.UNSOLICITED_PROPOSAL_HALF
                                                                                    .NOOFEPISODES
                                                                            }{" "}
                                                                        </div>
                                                                        <div className="text-content-unsolicated-width">
                                                                            {proposalData[0]?.noOfEpisodes}
                                                                        </div>
                                                                    </div>
                                                                    <div className="unsolicated-proposal-text-width">
                                                                        <div className="unsolicated-heading">
                                                                            {
                                                                                Globals.UNSOLICITED_PROPOSAL_HALF
                                                                                    .EPDURATION
                                                                            }{" "}
                                                                        </div>
                                                                        <div className="text-content-unsolicated-width">
                                                                            {proposalData[0]?.episodeDuration}
                                                                        </div>
                                                                    </div>
                                                                    <div className="unsolicated-proposal-text-width">
                                                                        <div className="unsolicated-heading">
                                                                            {
                                                                                Globals.UNSOLICITED_PROPOSAL_HALF
                                                                                    .TOTALEPDURATION
                                                                            }{" "}
                                                                        </div>
                                                                        <div className="text-content-unsolicated-width">
                                                                            {proposalData[0]?.totalEpisodesDuration ||
                                                                                proposalData[0]?.noOfEpisodes *
                                                                                proposalData[0]?.episodeDuration}
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <div className="unsolicated-proposal-text-width">
                                                                    <div className="unsolicated-heading">
                                                                        {
                                                                            Globals.UNSOLICITED_PROPOSAL_HALF
                                                                                .DURATIONINMINS
                                                                        }{" "}
                                                                    </div>
                                                                    <div className="text-content-unsolicated-width">
                                                                        {proposalData[0]?.episodeDuration}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            <div className="proposal-heading">
                                                                {Globals.UNSOLICITED_PROPOSAL_HALF.SYNOPSIS}
                                                            </div>
                                                            <p className="text-content">
                                                                {proposalData[0]?.synopsis ? (
                                                                    <>
                                                                        {proposalData[0]?.synopsis.length > 294 ? (
                                                                            <>
                                                                                {isSynopsisExpanded
                                                                                    ? proposalData[0]?.synopsis
                                                                                    : `${proposalData[0]?.synopsis.substring(
                                                                                        0,
                                                                                        294
                                                                                    )}...`}
                                                                                <div className="view">
                                                                                    <span
                                                                                        className="view-more"
                                                                                        onClick={toggleSynopsis}
                                                                                    >
                                                                                        {isSynopsisExpanded
                                                                                            ? "View Less"
                                                                                            : "View More"}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            proposalData[0]?.synopsis
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    "N/A"
                                                                )}
                                                            </p>
                                                            <div className="proposal-heading">
                                                                {Globals.SOLICITED_PROPOSAL.LOGLINE}
                                                            </div>
                                                            <p className="text-content">
                                                                {proposalData[0]?.logLine ? (
                                                                    <>
                                                                        {proposalData[0]?.logLine.length > 294 ? (
                                                                            <>
                                                                                {isLogLineExpanded
                                                                                    ? proposalData[0]?.logLine
                                                                                    : `${proposalData[0]?.logLine.substring(
                                                                                        0,
                                                                                        294
                                                                                    )}...`}
                                                                                <div className="view">
                                                                                    <span
                                                                                        className="view-more"
                                                                                        onClick={toggleLogLine}
                                                                                    >
                                                                                        {isLogLineExpanded
                                                                                            ? "View Less"
                                                                                            : "View More"}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            proposalData[0]?.logLine
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    "N/A"
                                                                )}
                                                            </p>

                                                            <div className="unsolicated-heading">
                                                                {Globals.UNSOLICITED_PROPOSAL_HALF.TARGET_BUDGET}{" "}
                                                            </div>
                                                            <div className="text-content bottom-spacing">
                                                                {proposalData[0]?.currency}{" "}
                                                                {formatCurrency(proposalData[0]?.targetBudget)}
                                                            </div>
                                                            {/* </div> */}

                                                            {(proposalData[0]?.formatType==='E'||proposalData[0]?.formatType==='M')&&<><div className="unsolicated-heading">
                                                                                     {Globals.UNSOLICITED_PROPOSAL_HALF.EPISODE_STRUCTURE}
                                                                                 </div>
                                                                                 <p className="text-content">
                                                                                     {proposalData[0]?.episodeStructure ? (
                                                                                         <>
                                                                                             {proposalData[0]?.episodeStructure.length > 294 ? (
                                                                                                 <>
                                                                                                     {isepisodeStructureExpanded
                                                                                                         ? proposalData[0]?.episodeStructure
                                                                                                         : `${proposalData[0]?.episodeStructure.substring(0, 294)}...`}
                                                                                                     <div className='view'>
                                                                                                         <span className="view-more" onClick={toggleEpisode}>
                                                                                                             {isepisodeStructureExpanded ? "View Less" : "View More"}
                                                                                                         </span></div>
                                                                                                 </>
                                                                                             ) : (
                                                                                                 proposalData[0]?.episodeStructure
                                                                                             )}
                                                                                         </>
                                                                                     ) : (
                                                                                         "N/A"
                                                                                     )}
                                                                                 </p></>}

                                                            <div className="unsolicated-heading">
                                                                {Globals.UNSOLICITED_PROPOSAL_HALF.LOCATION}
                                                            </div>
                                                            <p className="text-content">
                                                                {proposalData[0]?.locationStudioInfo ? (
                                                                    <>
                                                                        {proposalData[0]?.locationStudioInfo.length >
                                                                            294 ? (
                                                                            <>
                                                                                {islocationStudioInfoExpanded
                                                                                    ? proposalData[0]?.locationStudioInfo
                                                                                    : `${proposalData[0]?.locationStudioInfo.substring(
                                                                                        0,
                                                                                        294
                                                                                    )}...`}
                                                                                <div className="view">
                                                                                    <span
                                                                                        className="view-more"
                                                                                        onClick={toggleLocation}
                                                                                    >
                                                                                        {islocationStudioInfoExpanded
                                                                                            ? "View Less"
                                                                                            : "View More"}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            proposalData[0]?.locationStudioInfo
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    "N/A"
                                                                )}
                                                            </p>

                                                            <div className="unsolicated-heading">
                                                                {
                                                                    Globals.UNSOLICITED_PROPOSAL_HALF
                                                                        .CAST_PRESENTER_INFO
                                                                }
                                                            </div>
                                                            <p className="text-content">
                                                                {proposalData[0]?.castPresenterInfo ? (
                                                                    <>
                                                                        {proposalData[0]?.castPresenterInfo.length >
                                                                            294 ? (
                                                                            <>
                                                                                {iscastPresenterInfoExpanded
                                                                                    ? proposalData[0]?.castPresenterInfo
                                                                                    : `${proposalData[0]?.castPresenterInfo.substring(
                                                                                        0,
                                                                                        294
                                                                                    )}...`}
                                                                                <div className="view">
                                                                                    <span
                                                                                        className="view-more"
                                                                                        onClick={toggleCast}
                                                                                    >
                                                                                        {iscastPresenterInfoExpanded
                                                                                            ? "View Less"
                                                                                            : "View More"}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            proposalData[0]?.castPresenterInfo
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    "N/A"
                                                                )}
                                                            </p>

                                                            <div className="unsolicated-heading">
                                                                {
                                                                    Globals.UNSOLICITED_PROPOSAL_HALF
                                                                        .BRAND_INTEGRATION_OPPORTUNITIES
                                                                }
                                                            </div>
                                                            <p className="text-content">
                                                                {proposalData[0]?.brandIntegration ? (
                                                                    <>
                                                                        {proposalData[0]?.brandIntegration.length >
                                                                            294 ? (
                                                                            <>
                                                                                {isbrandIntegrationExpanded
                                                                                    ? proposalData[0]?.brandIntegration
                                                                                    : `${proposalData[0]?.brandIntegration.substring(
                                                                                        0,
                                                                                        294
                                                                                    )}...`}
                                                                                <div className="view">
                                                                                    <span
                                                                                        className="view-more"
                                                                                        onClick={toggleBrand}
                                                                                    >
                                                                                        {isbrandIntegrationExpanded
                                                                                            ? "View Less"
                                                                                            : "View More"}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            proposalData[0]?.brandIntegration
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    "N/A"
                                                                )}
                                                            </p>

                                                            <div className="unsolicated-heading">
                                                                {Globals.UNSOLICITED_PROPOSAL_HALF.PROJECT_STATUS}
                                                            </div>
                                                            <p className="text-content">
                                                                {proposalData[0]?.synopsis ? (
                                                                    <>
                                                                        {proposalData[0]?.projectStatus.length >
                                                                            294 ? (
                                                                            <>
                                                                                {isprojectStatusExpanded
                                                                                    ? proposalData[0]?.projectStatus
                                                                                    : `${proposalData[0]?.projectStatus.substring(
                                                                                        0,
                                                                                        294
                                                                                    )}...`}
                                                                                <div className="view">
                                                                                    <span
                                                                                        className="view-more"
                                                                                        onClick={toggleProjectStatus}
                                                                                    >
                                                                                        {isprojectStatusExpanded
                                                                                            ? "View Less"
                                                                                            : "View More"}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            (proposalData[0]?.projectStatus !== "" && proposalData[0]?.projectStatus !== null) ? proposalData[0]?.projectStatus : 'N/A'
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    "N/A"
                                                                )}
                                                            </p>

                                                            <div className="unsolicated-heading">
                                                                {Globals.UNSOLICITED_PROPOSAL_HALF.KEY_TEAM}
                                                            </div>
                                                            <p className="text-content">
                                                                {proposalData[0]?.keyTeams ? (
                                                                    <>
                                                                        {proposalData[0]?.keyTeams.length > 294 ? (
                                                                            <>
                                                                                {iskeyTeamsExpanded
                                                                                    ? proposalData[0]?.keyTeams
                                                                                    : `${proposalData[0]?.keyTeams.substring(
                                                                                        0,
                                                                                        294
                                                                                    )}...`}
                                                                                <div className="view">
                                                                                    <span
                                                                                        className="view-more"
                                                                                        onClick={toggleKeyteam}
                                                                                    >
                                                                                        {iskeyTeamsExpanded
                                                                                            ? "View Less"
                                                                                            : "View More"}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            proposalData[0]?.keyTeams
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    "N/A"
                                                                )}
                                                            </p>
                                                            {proposalData[0]?.artistName && (
                                                                <div className="unsolicated-proposal-text-width">
                                                                    <div className="unsolicated-heading">
                                                                        {
                                                                            Globals.UNSOLICITED_PROPOSAL_HALF
                                                                                .ARTIST_NAME
                                                                        }{" "}
                                                                    </div>
                                                                    <div className="text-content-unsolicated-width">
                                                                        {proposalData[0]?.artistName}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {proposalData[0]?.songName && (
                                                                <div className="unsolicated-proposal-text-width">
                                                                    <div className="unsolicated-heading">
                                                                        {Globals.UNSOLICITED_PROPOSAL_HALF.SONG_NAME}{" "}
                                                                    </div>
                                                                    <div className="text-content-unsolicated-width">
                                                                        {proposalData[0]?.songName}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            <div className="unsolicated-heading">
                                                                {
                                                                    Globals.UNSOLICITED_PROPOSAL_HALF
                                                                        .REFERENCE_LINKS
                                                                }
                                                            </div>
                                                            <div className="text-content">
                                                                {(proposalData[0]?.referenceLinks !== '' && proposalData[0]?.referenceLinks !== null) ?
                                                                    proposalData[0].referenceLinks
                                                                        .split(",")
                                                                        .map((link, index) => {
                                                                            const trimmedLink = link.trim();
                                                                            const linkVariableName = `Reference Link ${index + 1
                                                                                }`;

                                                                            return (
                                                                                <span key={index} className="refflink">
                                                                                    <a
                                                                                        //href={trimmedLink}
                                                                                        href={
                                                                                            trimmedLink.startsWith("http://") ||
                                                                                                trimmedLink.startsWith("https://")
                                                                                                ? trimmedLink
                                                                                                : `http://${trimmedLink}`
                                                                                        }
                                                                                        alt={linkVariableName}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        className="link-value"
                                                                                    >
                                                                                        {linkVariableName}
                                                                                    </a>
                                                                                    {index <
                                                                                        proposalData[0].referenceLinks.split(
                                                                                            ","
                                                                                        ).length -
                                                                                        1 && (
                                                                                            <span className="separator">, </span>
                                                                                        )}
                                                                                </span>
                                                                            );
                                                                        }): 'N/A'}
                                                            </div>
                                                        </div>
                                                        <img src={Globals.IMG.LINE} alt="" />
                                                        <div className="proposal-right-content">
                                                            {fileItems.length > 0 ? (
                                                                <div>{fileItems.map(({ foundDoc, docFor, heading }) => <DocumentListItem foundDoc={foundDoc} docFor={docFor} heading={heading} />)}</div>
                                                            ) : (
                                                                <p>N/A</p>
                                                            )}
                                                        </div>
                                                    </div></> : contentDataStatus &&
                                                        contentDataStatus?.length > 0 ? (
                                                    <NoResultsComponent
                                                        data={{
                                                            message: Globals.HALF_PAGE_MESSAGE,
                                                            img: Globals.IMG.HALF_PAGE_ERROR,
                                                            submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                                                            className: "ErrorHeader",
                                                            subclassName: "SubError",
                                                            outerWrapper: "HalfPageWrapper",
                                                            button: "reload",
                                                        }}
                                                        handleReload={fetchProposalHalfPage}
                                                    />
                                                ) : (
                                                    <div
                                                        className="NoResultsComponent"
                                                        style={{ height: "80vh" }}
                                                    >
                                                        <Loader height={50} width={50} />
                                                    </div>
                                                )}
                                                    </div>
                                                    </>)}
            </div>}
        </div>
        <div className="brief-button-group-container brief-fixed-footer">
            <div className="brief-button-group">
                <button
                            className="brief-cancel-btn"
                            onClick={() => navigate(OldGlobals.NAVPATH.TICKETS)}
                          >
                            {Globals.CLOSE}
                          </button>
                {(CryptoUtils.getFromLocalStorage("roleId")[0] === 4 || CryptoUtils.getFromLocalStorage("roleId") === '4' || CryptoUtils.getFromLocalStorage("roleId")[0] === 1 || CryptoUtils.getFromLocalStorage("roleId") === "3" || CryptoUtils.getFromLocalStorage("roleId")[0] === 3)  && ticketData.status === 0 &&<Button
                    title={Globals.RESOLVE}
                    id="cta_success"
                    action={updateStatus}
                />}
            </div>
            {isLoading &&<div className="NoResultsComponent" style={{ height: '80vh' }}>
                                                            <Loader height={50} width={50} component={"Tickets"}/>
                                                        </div>}
        </div>
        {popupState &&
                        showPopup(
                            Globals.RAISE_TICKET.POPUP[popupState].TITLE,
                            Globals.RAISE_TICKET.POPUP[popupState].MESSAGE,
                            Globals.RAISE_TICKET.POPUP[popupState].BUTTON_TEXT,
                        )}
    </div>
)
}